import type { TagSheetAd, TagSheetParseResult } from '../types';
import { validateDrop } from '../validation/validateDrop';
import { transformAdForLineItem } from './ads';

export const sanitizeAds = (parseResult: TagSheetParseResult): TagSheetParseResult => {
  const displaced: TagSheetAd[] = [];

  const sanitizedLineItems = parseResult.lineItems.map((lineItem) => {
    const compatibleAds: TagSheetAd[] = [];

    lineItem.tagSheetAds.forEach((ad) => {
      const error = validateDrop(ad, lineItem);

      if (error) {
        displaced.push(ad);
      } else {
        compatibleAds.push(transformAdForLineItem(ad, lineItem));
      }
    });

    return { ...lineItem, tagSheetAds: compatibleAds };
  });

  return {
    ...parseResult,
    unmappedAds: [...parseResult.unmappedAds, ...displaced],
    lineItems: sanitizedLineItems,
  };
};
